import React from 'react';
import { Link } from 'react-router-dom';
import { BOAT_RACE_LOCALES, getBoatRaceLocale } from '../config/boatRacePostUtils';
import './BoatRaceLanguageSwitcher.css';

/**
 * @param {object} props
 * @param {object} props.post — current featured post with locale + alternateSlug
 * @param {string} [props.variant] — 'bar' (article) or 'filter' (list)
 * @param {string} [props.localeFilter] — 'all' | 'en' | 'ml' for filter variant
 * @param {(locale: string) => void} [props.onLocaleFilterChange]
 */
const BoatRaceLanguageSwitcher = ({
  post,
  variant = 'bar',
  localeFilter = 'all',
  onLocaleFilterChange,
}) => {
  if (variant === 'filter') {
    return (
      <div className="boat-race-lang" role="group" aria-label="Filter by language">
        <span className="boat-race-lang__label">Language</span>
        <div className="boat-race-lang__tabs">
          <button
            type="button"
            className={`boat-race-lang__tab${localeFilter === 'all' ? ' boat-race-lang__tab--active' : ''}`}
            onClick={() => onLocaleFilterChange?.('all')}
            aria-pressed={localeFilter === 'all'}
          >
            All
          </button>
          <button
            type="button"
            className={`boat-race-lang__tab${localeFilter === 'en' ? ' boat-race-lang__tab--active' : ''}`}
            onClick={() => onLocaleFilterChange?.('en')}
            aria-pressed={localeFilter === 'en'}
          >
            {BOAT_RACE_LOCALES.en.nativeLabel}
          </button>
          <button
            type="button"
            className={`boat-race-lang__tab${localeFilter === 'ml' ? ' boat-race-lang__tab--active' : ''}`}
            onClick={() => onLocaleFilterChange?.('ml')}
            aria-pressed={localeFilter === 'ml'}
          >
            {BOAT_RACE_LOCALES.ml.nativeLabel}
          </button>
        </div>
      </div>
    );
  }

  if (!post?.alternateSlug) return null;

  const current = getBoatRaceLocale(post);
  const alternateLocale = post.locale === 'ml' ? BOAT_RACE_LOCALES.en : BOAT_RACE_LOCALES.ml;

  return (
    <nav className="boat-race-lang boat-race-lang--article" aria-label="Article language">
      <span className="boat-race-lang__label">Read in</span>
      <div className="boat-race-lang__tabs">
        <span
          className="boat-race-lang__tab boat-race-lang__tab--active"
          aria-current="page"
        >
          {current.nativeLabel}
        </span>
        <Link
          to={`/blog/${post.alternateSlug}`}
          className="boat-race-lang__tab boat-race-lang__tab--link"
        >
          {alternateLocale.nativeLabel}
        </Link>
      </div>
    </nav>
  );
};

export default BoatRaceLanguageSwitcher;
